import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { commonActions } from 'srcReact/components'
import Input from 'srcReact/components/common2/Input'
import Label from 'srcReact/components/common2/Label'
import Spinner from 'srcReact/components/common2/Spinner'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'
import Icon from 'srcReact/components/icons/Icon'
import { popupWindow } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { openInNewTab } from 'srcReact/helpers/utils'
import { mixrActions } from 'srcReact/Mixr/actions'
import Modal from 'srcReact/components/common2/Modal'
import MySettingsPopin from 'srcReact/components/popinsContent/MySettingsPopin'
import history from 'srcReact/helpers/history'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'

function JoinInLink({
  setJoinInLinkRef,
  joinLink,
  handlejoinLinkChange,
  handleJoinLinkBlur,
  handleVideoOptionChange,
  selected,
  editMode
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [buttonTriggered, setButtonTriggered] = useState(false)
  const [showCustomTextField, setShowCustomTextField] = useState(selected === 'none')
  const [selectedOption, setSelectedOption] = useState(selected)
  const [connectionSuccess, setConnectionSuccess] = useState('')
  const [showMySettingsPopup, setShowMySettingsPopup] = useState(false)
  const [connectionType, setConnectionType] = useState('')
  const [availableAPIs, setAvailableAPIs] = useState([])

  const {
    common: { isNative },
    integration: {
      thirdPartyconnection: { loading, API_connection, login_url, error, connection_saved },
      default_meeting,
      activeIntegrations,
      availableIntegrations,
      triggerAddToCalendar
    }
  } = useSelector((state) => state)

  useEffect(() => {
    const organizationId = getCurrentOrgId()
    dispatch(integrationActions.getAvailableOrgConnections(organizationId))
  }, [])

  useEffect(() => {
    if (availableIntegrations?.list?.length > 0) {
      const activeVirtualAPIS = availableIntegrations.list.filter(
        (api) => api.usage === 'virtual_meeting' && api.is_active === 1
      )
      setAvailableAPIs(activeVirtualAPIS)
    }
  }, [availableIntegrations])

  useEffect(() => {
    if (buttonTriggered && !loading) {
      if (!API_connection && login_url?.length > 0) {
        if (isNative) {
          // openInNewTab(login_url)
          setShowMySettingsPopup(true)
        } else {
          popupWindow(login_url, 'virtual_meet_connection', '600', '600')
        }
        setButtonTriggered(false)
      } else if (API_connection) {
        const links = {
          google: 'Google Meet',
          microsoft: 'Microsoft Teams',
          zoom: 'Zoom'
        }
        setConnectionSuccess(
          editMode
            ? t('event.create.venue.connectionSuccessUpdate', { option: links[selectedOption] })
            : t('event.create.venue.connectionSuccessCreate', { option: links[selectedOption] })
        )
        setButtonTriggered(false)
      }
    }
  }, [buttonTriggered, loading, API_connection, connection_saved, login_url, error])

  useEffect(() => {
    if (triggerAddToCalendar && selectedOption !== 'none') {
      const defaultCalendar = activeIntegrations?.list?.find((x) => x.is_default === 1 && x.usage === 'virtual_meeting')
      const idExternalApiAuth = defaultCalendar?.id_external_api_auth || 0
      if (!idExternalApiAuth) {
        localStorage.removeItem('id_external_api_auth')
        setButtonTriggered(true)
        const organizationId = getCurrentOrgId()
        dispatch(integrationActions.getExternalAPIConnection(selectedOption, organizationId))
      } else {
        const links = {
          google: 'Google Meet',
          microsoft: 'Microsoft Teams',
          zoom: 'Zoom'
        }
        localStorage.setItem('id_external_api_auth', idExternalApiAuth)
        dispatch(mixrActions.setMixrData([{ key: 'id_external_api_auth', value: idExternalApiAuth }]))
        setConnectionSuccess(
          editMode
            ? t('event.create.venue.connectionSuccessUpdate', { option: links[selectedOption] })
            : t('event.create.venue.connectionSuccessCreate', { option: links[selectedOption] })
        )
      }
    }
    return () => {
      if (triggerAddToCalendar) {
        dispatch(integrationActions.clearData())
      }
    }
  }, [triggerAddToCalendar, selectedOption])

  const closeMySettingsPopup = () => {
    setShowMySettingsPopup(false)
  }

  const handleMySettings = () => {
    closeMySettingsPopup()
    history.push('/0/settings/integrations')
  }

  const handleConnect = (type) => {
    // Native if the user has authenticated with Google, Microsoft Teams, and Zoom for the virtual meeting feature
    // if (isNative && !default_meeting[type]?.id_external_api_auth) {
    setConnectionType(
      type === 'google' ? 'Google Meet' : type === 'microsoft' ? 'Microsoft Teams' : type === 'zoom' ? 'Zoom' : 'none'
    )
    // setShowMySettingsPopup(true)
    // } else {
    localStorage.removeItem('addtocal')
    setConnectionSuccess('')
    setShowCustomTextField(false)
    setSelectedOption(type)
    handleVideoOptionChange(
      type === 'google' ? 'GoogleMeet' : type === 'microsoft' ? 'MicrosoftTeams' : type === 'zoom' ? 'Zoom' : 'none'
    )
    const organizationId = getCurrentOrgId()
    dispatch(integrationActions.getActiveIntegrations(organizationId, 'virtual_meeting'))
    // }
  }

  const handleCustom = () => {
    setConnectionSuccess('')
    setShowCustomTextField(true)
    setSelectedOption('none')
    handleVideoOptionChange('none')
  }

  return (
    <React.Fragment>
      <div className={styles.joinLinkContainer}>
        <TooltipWrapper
          content={t('event.create.venue.customLink')}
          triggerElement={
            <button
              type='button'
              className={`${styles.option} ${(showCustomTextField || selected === 'none') && styles.selected} ${
                styles.customLink
              }`}
              onClick={handleCustom}
              aria-label={t('event.create.venue.customLink')}>
              <Icon styleModifier={styles.link} name='link' size='large24' />
              {selected === 'none' && <Icon name='check24' size='large24' styleModifier={styles.check} />}
              {t('global.custom')}
            </button>
          }
        />
        {availableAPIs?.length > 0 &&
          availableAPIs.map((api) => {
            if (api.external_api === 'google') {
              return (
                <TooltipWrapper
                  content={t('event.create.venue.joinWithOption', { option: 'google meet' })}
                  triggerElement={
                    <button
                      type='button'
                      className={`${styles.option} ${selected === 'GoogleMeet' && styles.selected} `}
                      aria-label={t('event.create.venue.joinWithOption', { option: 'google meet' })}
                      onClick={() => handleConnect('google')}>
                      {selected === 'GoogleMeet' && <Icon name='check24' size='large24' styleModifier={styles.check} />}
                      <img alt={t('calendars.outlook')} src={config.assetUrl + '/images/Google-Meet-Logo.jpg'} />
                    </button>
                  }
                />
              )
            } else if (api.external_api === 'microsoft') {
              return (
                <TooltipWrapper
                  content={t('event.create.venue.joinWithOption', { option: 'microsoft teams' })}
                  triggerElement={
                    <button
                      type='button'
                      className={`${styles.option} ${selected === 'MicrosoftTeams' && styles.selected} ${
                        styles.msTeam
                      }`}
                      aria-label={t('event.create.venue.joinWithOption', { option: 'microsoft teams' })}
                      onClick={() => handleConnect('microsoft')}>
                      {selected === 'MicrosoftTeams' && (
                        <Icon name='check24' size='large24' styleModifier={styles.check} />
                      )}
                      <img alt={t('calendars.outlook')} src={config.assetUrl + '/images/Microsoft_Office_Teams.png'} />
                    </button>
                  }
                />
              )
            } else if (api.external_api === 'zoom') {
              return (
                <TooltipWrapper
                  content={t('event.create.venue.joinWithOption', { option: 'zoom' })}
                  triggerElement={
                    <button
                      type='button'
                      className={`${styles.option} ${selected === 'Zoom' && styles.selected}`}
                      aria-label={t('event.create.venue.joinWithOption', { option: 'zoom' })}
                      onClick={() => handleConnect('zoom')}>
                      {selected === 'Zoom' && <Icon name='check24' size='large24' styleModifier={styles.check} />}
                      <img alt={t('calendars.outlook')} src={config.assetUrl + '/images/zoom.png'} />
                    </button>
                  }
                />
              )
            }
          })}
      </div>
      {showCustomTextField && (
        <div className={styles.joinInLinkContainer}>
          <Label ariaLabel={t('event.create.venue.customLink')}>{t('event.create.venue.customLink')}</Label>
          <Input
            className={styles.input}
            setRef={setJoinInLinkRef}
            type='url'
            isInvalid={joinLink.hasError}
            value={joinLink.value}
            placeholder={t('event.create.venue.joinLinkPlaceholder')}
            onChange={handlejoinLinkChange}
            onBlur={handleJoinLinkBlur}
          />
        </div>
      )}
      {loading && <Spinner />}
      {!loading && connectionSuccess && (
        <SuccessMessage className={styles.connectionSuccess} text={connectionSuccess} />
      )}
      {showMySettingsPopup && (
        <Modal nested isOpen={showMySettingsPopup} handleClose={closeMySettingsPopup} closeOnDocumentClick={true}>
          <MySettingsPopin
            closeModal={closeMySettingsPopup}
            connectionType={connectionType}
            handleMySettings={handleMySettings}
          />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default JoinInLink
